import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { EmailTemplate, EmailTemplatePosition } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class EmailTemplatesGeneralHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadCollection(): Observable<EmailTemplate[]> {
    return this.httpApi.get(`/email_templates`).pipe(map(data => data.emailTemplates));
  }

  public create(emailTemplate: Partial<EmailTemplate>) {
    return this.httpApi.post(`/email_templates`, null, { emailTemplate });
  }

  public update(emailTemplate: Partial<EmailTemplate>) {
    return this.httpApi.patch(`/email_templates/${emailTemplate.id}`, null, { emailTemplate });
  }

  public delete(id: number | string) {
    return this.httpApi.delete(`/email_templates/${id}`);
  }

  public updatePositions(positions: EmailTemplatePosition[]): Observable<EmailTemplate> {
    return this.httpApi.patch(`/email_templates/update_positions`, null, {
      email_templates: positions,
    });
  }

  public duplicate({ id }: { id: number }): Observable<EmailTemplate> {
    return this.httpApi
      .post(`/email_templates/${id}`, null, null)
      .pipe(map(data => data.emailTemplate));
  }
}
